import { render, staticRenderFns } from "./AddPrikazForm.vue?vue&type=template&id=0d7c44c4&scoped=true&"
import script from "./AddPrikazForm.vue?vue&type=script&lang=js&"
export * from "./AddPrikazForm.vue?vue&type=script&lang=js&"
import style0 from "./AddPrikazForm.vue?vue&type=style&index=0&id=0d7c44c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c44c4",
  null
  
)

export default component.exports